import { SvgIcon, SvgIconProps } from "designSystem/index";
import React, { FunctionComponent } from "react";
import { grey } from "designSystem/styles/color";

const SphereIcon: FunctionComponent<SvgIconProps> = ({ ...props }) => {
	return (
		<SvgIcon {...props} viewBox="0 0 16 16">
			<path d="M8 1.5C4.40875 1.5 1.5 4.40875 1.5 8C1.5 11.5913 4.40875 14.5 8 14.5C11.5913 14.5 14.5 11.5913 14.5 8C14.5 4.40875 11.5913 1.5 8 1.5ZM8 13.2C5.1335 13.2 2.8 10.8665 2.8 8C2.8 5.1335 5.1335 2.8 8 2.8C10.8665 2.8 13.2 5.1335 13.2 8C13.2 10.8665 10.8665 13.2 8 13.2Z" fill={grey[900]} />
			<path
				d="M7.34978 4.04614C5.7089 4.41813 4.41791 5.70911 4.0459 7.34998"
				stroke={grey[900]}
				strokeLinecap="round"
			/>
		</SvgIcon>
	);
};

export default SphereIcon;